module.exports = __webpack_public_path__ + "img/logo-茂名市人民医院.ea97948e.png";